<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Box Office Summary Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <!-- <b-dropdown
                :disabled="isRoleID"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("show") }}
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getBoxOfficeSummaryReport(false)"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            class="col-lg-6 col-xl-3 align-self-center mt-2 d-flex justify-content-end align-items-center"
            v-if="getBoxOfficeReport.length"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- @click="generateReport('boxOfficeReceiptReport')" -->
            <a
              target="_blank"
              @click="getBoxOfficeSummaryReport(true)"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                style="cursor:pointer"
                height="25"
                width="25"
              />
            </a>
            <!-- <a target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a> -->
            <span  @click="excelDownload()" title="Download as Excel" style="cursor:pointer">
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </span>
          </div>
        </div>
      </div>

          <div class="table-scroll">
            <table
              class="swc-report-table swc_table_header"
              border="1"
              v-if="getBoxOfficeReport.length > 0"
            >
              <thead class="bg-lightgrey">
                <tr>
                  <th rowspan="2">Movie</th>
                  <th rowspan="2" v-if="(groupByMovieShowDatetime )">Show Date</th>
                  <th rowspan="2" v-if="(groupByMovieShowDatetime )">Show Time</th>
                  <th colspan="4">Paid (excl Comps)</th>
                  <th>Comps</th>
                  <th colspan="4">Paid (incl Comps)</th>
                  <th colspan="2" v-if="!hideonIraq">Box office</th>
                </tr>
                <tr>
                  <th>Box Office</th>
                  <th>Online</th>
                  <th>Admits</th>
                  <th>Gross Box Office</th>
                  <th></th>
                  <th>Box Office</th>
                  <th>Online</th>
                  <th>Admits</th>
                  <th>Gross Box Office</th>
                  <th v-if="!hideonIraq">Tax</th>
                  <th v-if="!hideonIraq">Net</th>
                </tr>
              </thead>
              <template
                v-for="(boxOfficeData,
                boxOfficeDataIndex) in getBoxOfficeReport"
              >
                <tr :key="boxOfficeDataIndex">
                  <td
                    :rowspan="
                      boxOfficeData.show_time_array.length +
                        grandTotalNeededCount()
                    "
                    class="text-left"
                  >
                    {{ boxOfficeData.movie_title }}-{{ boxOfficeData.mf_name }}
                  </td>
                </tr>
                          <template
                  v-for="(showTimes,
                  showTimesIndex) in boxOfficeData.show_time_array"
                >
                  <tr :key="showTimesIndex">
                    <td class="text-right" v-if="(groupByMovieShowDatetime )">
                      {{ showTimes.show_date }}
                    </td>
                    <td class="text-right" v-if="(groupByMovieShowDatetime )">
                      {{ showTimes.show_time }}
                    </td>
                    <td class="text-right">
                      {{ (showTimes.boxOffice_excl_compl).toFixed(0) }}
                    </td>
                    <td class="text-right">
                      {{ showTimes.online_excl_compl }}
                    </td>
                    <td class="text-right">
                      {{ showTimes.admits_excl_t_gross_amount_before_offer }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          showTimes.paid_excl_t_gross_amount_before_offer
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{ showTimes.is_complementory_ticket }}
                    </td>
                    <td class="text-right">
                      {{ showTimes.boxOffice_incl_compl }}
                    </td>
                    <td class="text-right">
                      {{ showTimes.online_incl_compl }}
                    </td>
                    <td class="text-right">
                      {{ showTimes.admits_incl_comp }}
                    </td>

                    <td class="text-right">
                      {{
                        currFormat(
                          showTimes.paid_incl_t_gross_amount_before_offer
                        )
                      }}
                    </td>
                    <td class="text-right" v-if="!hideonIraq">
                      {{
                        currFormat(
                          showTimes.paid_incl_tax_gross_amount_before_offer
                        )
                      }}
                    </td>
                    <td class="text-right" v-if="!hideonIraq">
                      {{
                        currFormat(
                          showTimes.paid_incl_net_gross_amount_before_offer
                        )
                      }}
                    </td>
                  </tr>
                </template>
                <tr
                  :key="boxOfficeDataIndex"
                  class="bg-lightgrey font-weight-bold"
                  v-if="grandTotalNeeded()"
                >
                  <td colspan="2" class="text-left">Grand Total</td>
                  <td class="text-right">
                    {{
                      boxOfficeData.show_time_array.reduce(
                        (acc, { boxOffice_excl_compl }) => {
                          return acc + boxOffice_excl_compl;
                        },
                        0
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      boxOfficeData.show_time_array.reduce(
                        (acc, { online_incl_compl }) => {
                          return acc + online_incl_compl;
                        },
                        0
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      boxOfficeData.grand_total
                        .admits_excl_t_gross_amount_before_offer
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        boxOfficeData.grand_total
                          .paid_excl_t_gross_amount_before_offer
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{ boxOfficeData.grand_total.is_complementory_ticket }}
                  </td>
                  <td class="text-right">
                    <!-- {{ currFormat(boxOfficeData.grand_total.admits_incl_comp) }} -->
                    {{
                      boxOfficeData.show_time_array.reduce(
                        (acc, { boxOffice_incl_compl }) => {
                          return acc + boxOffice_incl_compl;
                        },
                        0
                      )
                    }}
                  </td>
                  <td class="text-right">
                    <!-- {{
                    currFormat(
                      boxOfficeData.grand_total
                        .online_incl_compl
                    )
                  }} -->
                    {{
                      boxOfficeData.show_time_array.reduce(
                        (acc, { online_incl_compl }) => {
                          return acc + online_incl_compl;
                        },
                        0
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      boxOfficeData.show_time_array.reduce(
                        (acc, { admits_incl_comp }) => {
                          return acc + admits_incl_comp;
                        },
                        0
                      ).toFixed(0)
                    }}
                  </td>

                  <td class="text-right">
                    {{
                      boxOfficeData.show_time_array
                        .reduce(
                          (acc, { paid_incl_t_gross_amount_before_offer }) => {
                            return acc + paid_incl_t_gross_amount_before_offer;
                          },
                          0
                        )
                        .toFixed(2)
                    }}
                  </td>

                  <td class="text-right">
                    {{
                      currFormat(
                        boxOfficeData.grand_total
                          .paid_incl_tax_gross_amount_before_offer
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        boxOfficeData.grand_total
                          .paid_incl_net_gross_amount_before_offer
                      )
                    }}
                  </td>
                </tr>
              </template>
                 <thead class="bg-lightgrey">
                <tr>
                  <th>Grand Total</th>
                  <th 
                  v-if="hideonIraq"
                  v-for="(item,index222) in Object.keys(grandTotalBoxOffice).splice(0,Object.keys(grandTotalBoxOffice).length-2)" :key="index222" class="text-right"> {{
                    currFormat(grandTotalBoxOffice[item] || 0)
                    }}</th>

                     <th 
                 v-if="!hideonIraq"
                  v-for="(item,index222) in Object.keys(grandTotalBoxOffice)" :key="index222" class="text-right"> {{
                    ["boxOffice_excl_compl","online_excl_compl","admits_excl_t_gross_amount_before_offer"].includes(item) ? grandTotalBoxOffice[item]:currFormat(grandTotalBoxOffice[item] || 0)
                    }}</th>
                 
                </tr>
              </thead>
            </table>
          </div>
        </div>
    
        
      

      <table
        v-if="getBoxOfficeReport.length === 0"
        class="swc-report-table swc_table_header"
        border="1"
      >
        <thead>
          <tr class="bg-lightgrey">
            <th rowspan="2">Movie</th>
            <th rowspan="2" v-if="(groupByMovieShowDatetime )">Show Date</th>
            <th rowspan="2" v-if="(groupByMovieShowDatetime )">Show Time</th>
            <th colspan="4">Paid (excl Comps)</th>
            <th>Comps</th>
            <th colspan="4">Paid (incl Comps)</th>
            <th colspan="2"  v-if="!hideonIraq">Box office</th>
          </tr>
          <tr class="bg-lightgrey">
            <th>Box Office</th>
            <th>Online</th>
            <th>Admits</th>
            <th>Gross Box Office</th>
            <th></th>
            <th>Box Office</th>
            <th>Online</th>
            <th>Admits</th>
            <th>Gross Box Office</th>
            <th  v-if="!hideonIraq">Tax</th>
            <th  v-if="!hideonIraq">Net</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="14">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import VueHtml2pdf from "vue-html2pdf";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import { mapActions, mapGetters } from "vuex";
import { Role, CLIENT_NAME } from "@/helper/Role";

export default {
  components: {
    NoRecords,
    VueHtml2pdf
  },
  data() {
    return {
      BASEURL,

      isRoleID: false,
      submitted: false,
      pdfFileName: "",
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1
        },
        html2canvas: {
          scale: 1,
          useCORS: true
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape"
        }
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: ""
      },
      fromDate: new Date(),
      toDate: new Date(),
      getBoxOfficeReport: [],
      grandTotalBoxOffice:{
boxOffice_excl_compl:0,
online_excl_compl:0,
admits_excl_t_gross_amount_before_offer:0,
paid_excl_t_gross_amount_before_offer:0,
is_complementory_ticket:0,
boxOffice_incl_compl:0,
online_incl_compl:0,
admits_incl_comp:0,
paid_incl_t_gross_amount_before_offer:0,
paid_incl_tax_gross_amount_before_offer:0,
paid_incl_net_gross_amount_before_offer:0,

}
     
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
    }
  },
  mounted() {},
  computed: {
    groupByMovieShowDatetime() {
        

        if (String(this.CLIENT_SETUP_NAME).toUpperCase() == "IRAQ")
          return false;
        if (String(this.CLIENT_SETUP_NAME).toUpperCase() == "EMPIRE")
          return false;

        return true;
      // return !String(this.CLIENT_SETUP_NAME).toLowerCase()
      //   .includes(String(CLIENT_NAME.EMPIRE ).toLowerCase())
      
        // !String(this.CLIENT_SETUP_NAME).toUpperCase() == 'IRAQ'
        ;
    },
    hideonIraq(){
      
      return String(this.CLIENT_SETUP_NAME).toUpperCase()
        .includes(String(CLIENT_NAME.IRAQ ).toUpperCase())
        
    },
    

    ...mapGetters(["getOrganizationDetails"])
  },
  methods: {

    grandTotalNeededCount() {
      return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME || CLIENT_NAME.IRAQ == this.CLIENT_SETUP_NAME ? 1 : 2;
    },
    grandTotalNeeded() {
      console.log(CLIENT_NAME.EMPIRE, this.CLIENT_SETUP_NAME);
      return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME || CLIENT_NAME.IRAQ == this.CLIENT_SETUP_NAME ? false : true;
    },
    generateReport(type) {
      if (type == "boxOfficeReceiptReport") {
        this.$refs.html2Pdf &&
          this.$refs.html2Pdf.generatePdf &&
          this.$refs.html2Pdf.generatePdf();
      }
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      const date = new Date();
      this.pdfFileName = "Reports" + date.getTime();
      this.htmlToPdfOptions.filename =
        "Box Office Summary Report" + date.getTime();
      await html2pdf()
        .set(this.htmlToPdfOptions)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then(pdf => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            );
          }
        })
        .save();
    },

    getCinemaList: function() {
      MasterService.GetCinemas()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function(event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getBoxOfficeSummaryReport: function(isPdfValue = false) {
      let loader = this.$loading.show();
      this.submitted = true;
      this.getBoxOfficeReport = [];
        Object.keys(this.grandTotalBoxOffice).map(keeey=>{

                    this.grandTotalBoxOffice[keeey]=0
                  })

      let selectedCinemaId = this.dropDown.selectedCinemaId;

      let message;

      if (!selectedCinemaId) {
        message = "Please select a cinema";
      } else if (!this.fromDate) {
        message = "From Date field cannot be empty";
      } else if (!this.toDate) {
        message = "To Date field cannot be empty";
      } else if (moment(this.fromDate).isAfter(moment(this.toDate))) {
        message = "To date should be greater than from date";
      }

      if (message) {
        this.$toasted.show(message);
        return;
      }

      let payload = {
        cinema_id: selectedCinemaId,
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isPdf: isPdfValue,
      };
      ReportsService.GetBoxOfficeSummaryReport(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            console.log("data from api", data.Records);
            
            if(!this.groupByMovieShowDatetime ) {
              data.Records.forEach(movie => {
                if (movie.movieSummary && movie.movieSummary.length) {
                  movie._movieSummary = JSON.parse(JSON.stringify(movie.movieSummary))
                  movie._show_time_array = JSON.parse(JSON.stringify(movie.show_time_array))
                  movie.show_time_array = JSON.parse(JSON.stringify(movie.movieSummary))
                }
              })
            }

            this.getBoxOfficeReport = data.Records;
            if(this.getBoxOfficeReport.length){
                  if (isPdfValue && data.pdfpath) {
                  window.open(data.pdfpath, "_blank");
                }
              this.getBoxOfficeReport.map(boxOfficeData=>{
                boxOfficeData.show_time_array.map(_sss=>{
                  Object.keys(this.grandTotalBoxOffice).map(keeey=>{

                    this.grandTotalBoxOffice[keeey]=this.grandTotalBoxOffice[keeey] + (_sss[keeey] || 0)
                  })

                })
              })

            }


          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 660);
        });
    },
    excelDownload() {
      let new_records = [];
      let temp_arr = this.getBoxOfficeReport;
      temp_arr = this.getBoxOfficeReport.map(x => {
        x.show_time_array.map(z => {
          let obj = {
            ...x,
            ...z
          };
          new_records.push(obj);
        });
      });
      let data = [
        {
          sheet: "BoxOfficeSummary Report",
          columns: [
            {
              value: "movie_title",
              label: "Movie Name"
            },
            {
              value: "mf_name",
              label: "Movie Format"
            },
            {
              value: "show_date",
              label: "Show Date"
            },
            {
              value: "show_time",
              label: "Show Time"
            },
            {
              value: "boxOffice_excl_compl",
              label: "Box Office(excl)"
            },
            {
              value: "online_excl_compl",
              label: "Online(excl)"
            },
            {
              value: "admits_excl_t_gross_amount_before_offer",
              label: "Admits(excl)"
            },
            {
              value: "paid_excl_t_gross_amount_before_offer",
              label: "Gross Amount(excl)"
            },
            {
              value: "is_complementory_ticket",
              label: "Complementary Ticket"
            },
            {
              value: "boxOffice_incl_compl",
              label: "Box Office(incl)"
            },
            {
              value: "online_incl_compl",
              label: "Online(incl)"
            },
            {
              value: "admits_incl_comp",
              label: "Admits(incl)"
            },
            {
              value: "paid_incl_t_gross_amount_before_offer",
              label: "Gross Amount(incl)"
            },
            {
              value: "paid_incl_tax_gross_amount_before_offer",
              label: "Tax"
            },
            {
              value: "paid_incl_net_gross_amount_before_offer",
              label: "Net Amount"
            }

            //      Sold: 0,
            // gross_amount: 0,
            // offer_price: 0,
            // total_taxes: 0,
            // final_gross_amount: 0
          ].filter(header => {
            return this.groupByMovieShowDatetimes
              ? true
              : !header.value.startsWith('show_')
          }),
          content: new_records
        }
      ];
      let settings = {
        fileName: `BoxOfficeSummaryReport${new Date().getTime()}`
      };
      xlsx(data, settings);
    }
  }
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/BoxOfficeSummary.vue